import { computed } from 'vue';
// import { useMapGetter } from 'dashboard/composables/store';

/**
 * Composable para determinar el origen de un mensaje
 * @param {Object} messageProps - Las props del mensaje
 * @returns {Object} Objeto con información sobre el origen del mensaje
 */
export function useMessageOrigin(messageProps) {
  // Para testing, habilitamos siempre la feature
  const isFeatureEnabled = computed(() => true);

  // const isFeatureEnabledonAccount = useMapGetter(
  //   'accounts/isFeatureEnabledonAccount'
  // );
  // const isFeatureEnabled = computed(() =>
  //   isFeatureEnabledonAccount.value('message_source_differentiation')
  // );

  /**
   * Determina el origen del mensaje basado en las propiedades
   * @returns {'external'|'chatwoot'|'unknown'}
   */
  const messageOrigin = computed(() => {
    if (!isFeatureEnabled.value) return 'unknown';

    const { sourceId, senderType, messageType } = messageProps;

    // Mensajes de actividad no necesitan diferenciación
    if (messageType === 2) return 'unknown';

    // Primero detectamos mensajes desde dispositivo externo (celular)
    // Lógica de detección:
    // 1. Mensajes entrantes (incoming) normalmente vienen de dispositivo externo
    if (messageType === 0) {
      return 'external';
    }

    // 2. Mensajes con sourceId = desde dispositivo externo
    if (sourceId) {
      return 'external';
    }

    // 3. Mensajes con sender Contact = desde dispositivo externo
    if (senderType === 'Contact') {
      return 'external';
    }

    // NUEVA LÓGICA: Si llegamos aquí y es mensaje saliente, es de Chatwoot
    if (messageType === 1) {
      return 'chatwoot';
    }

    // Todo lo demás
    return 'unknown';
  });

  /**
   * Clase CSS para aplicar al mensaje según su origen
   */
  const originClass = computed(() => {
    if (!isFeatureEnabled.value) return '';

    const originMap = {
      external: 'message-from-external',
      chatwoot: 'message-from-chatwoot',
      unknown: '',
    };

    return originMap[messageOrigin.value] || '';
  });

  /**
   * Color del indicador según el origen
   */
  const originColor = computed(() => {
    if (!isFeatureEnabled.value) return '';

    const colorMap = {
      external: '#1f93ff', // Azul para mensajes externos
      chatwoot: '#4c1d95', // Azul oscuro casi morado para mensajes de Chatwoot
      unknown: '',
    };

    return colorMap[messageOrigin.value] || '';
  });

  /**
   * Texto descriptivo del origen
   */
  const originLabel = computed(() => {
    if (!isFeatureEnabled.value) return '';

    const labelMap = {
      external: 'Sent from mobile device',
      chatwoot: 'Sent from Chatwoot',
      unknown: '',
    };

    return labelMap[messageOrigin.value] || '';
  });

  return {
    isFeatureEnabled,
    messageOrigin,
    originClass,
    originColor,
    originLabel,
  };
}
